const buildConfig = {
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
  ALTERNATE_BACKEND_URL: process.env.REACT_APP_ALTERNATE_BACKEND_URL,
  PWA_URL: process.env.REACT_APP_PWA_URL,
  HOURS_CLOSE_TICKETS_AUTO: process.env.REACT_APP_HOURS_CLOSE_TICKETS_AUTO,
};

function getCurrentHostname() {
  if (typeof window === "undefined" || !window.location) return "";
  return (window.location.hostname || "").toLowerCase();
}

function backendFromPwaHostname(hostname) {
  const match = /^app-([a-z0-9-]+)\.mware\.com\.br$/i.exec(hostname || "");
  if (!match) return null;
  return `https://api-${match[1].toLowerCase()}.mware.com.br`;
}

function getRuntimeConfig(name, defaultValue = null) {
  if (typeof window !== "undefined" && window.ATNDPLUS_CONFIG) {
    const value = window.ATNDPLUS_CONFIG[name];
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }

  if (buildConfig[name]) {
    return buildConfig[name];
  }

  return defaultValue;
}

export function getBackendUrl() {
  // Authoritative tenant routing rule:
  // app-<tenant>.mware.com.br -> api-<tenant>.mware.com.br
  const routedBackend = backendFromPwaHostname(getCurrentHostname());
  if (routedBackend) return routedBackend;

  return getRuntimeConfig(
    "BACKEND_URL",
    "https://api-atendosim.mware.com.br"
  );
}

export function getAlternateBackendUrl() {
  return getRuntimeConfig(
    "ALTERNATE_BACKEND_URL",
    "https://atendosim.mware.com.br"
  );
}

export function getPwaUrl() {
  const currentOrigin =
    typeof window !== "undefined" && window.location && window.location.origin
      ? window.location.origin
      : "https://app-atendosim.mware.com.br";

  return getRuntimeConfig("PWA_URL", currentOrigin);
}

export function getHoursCloseTicketsAuto() {
  return getRuntimeConfig("HOURS_CLOSE_TICKETS_AUTO");
}

const fallbackBranding = {
  atendosim: {
    tenant: "atendosim",
    appName: "AtendoSim ATND+",
    shortName: "AtendoSim",
    subtitle: "Atendimento digital",
    manifestUrl: "/manifest-atendosim.json",
    iconBase: "/icons/atendosim",
  },
  querencia: {
    tenant: "querencia",
    appName: "Querência ATND+",
    shortName: "Querência",
    subtitle: "Atendimento digital",
    manifestUrl: "/manifest-querencia.json",
    iconBase: "/icons/querencia",
  },
  iasb: {
    tenant: "iasb",
    appName: "IASB ATND+",
    shortName: "IASB",
    subtitle: "Atendimento IASB",
    manifestUrl: "/manifest-iasb.json",
    iconBase: "/icons/iasb",
  },
  juina: {
    tenant: "juina",
    appName: "Juína ATND+",
    shortName: "Juína",
    subtitle: "Atendimento digital",
    manifestUrl: "/manifest-juina.json",
    iconBase: "/icons/juina",
  },
};

export function getTenantBranding() {
  if (typeof window !== "undefined" && window.ATNDPLUS_CONFIG) {
    const config = window.ATNDPLUS_CONFIG;
    if (config.APP_NAME && config.ICON_BASE) {
      return {
        tenant: config.BRAND_TENANT || "atendosim",
        requestedTenant: config.TENANT || config.BRAND_TENANT || "atendosim",
        appName: config.APP_NAME,
        shortName: config.APP_SHORT_NAME || config.APP_NAME,
        subtitle: config.APP_SUBTITLE || "Atendimento digital",
        manifestUrl: config.MANIFEST_URL || "/manifest-atendosim.json",
        iconBase: config.ICON_BASE || "/icons/atendosim",
      };
    }
  }

  const hostname = getCurrentHostname();
  const match = /^app-([a-z0-9-]+)\.mware\.com\.br$/i.exec(hostname || "");
  const requestedTenant = match ? match[1].toLowerCase() : "atendosim";
  const branding = fallbackBranding[requestedTenant] || fallbackBranding.atendosim;
  return { ...branding, requestedTenant };
}

